export enum HealeeSex {
  Male = 1,
  Female = 2,
  PreferNotToSay = 3,
}
